import React from "react";
import { Outlet, useParams } from "react-router-dom";
import { useAssociatedProgramBehaviourFactory } from "apps/console/modules/program/workflow/associateProgram/profile/activity/details/components/associatedProgramBehaviourFactory";
import { ShortlistParticipantServiceProvider } from "apps/console/modules/program/workflow/associateProgram/shortlist/context";
import { useMyExperienceshortlistService } from "./service";
import { useCopies } from "shared/hooks/useCopies";
import CheckBox from "shared/form/core/checkbox";
import xor from "lodash/xor";
import Button from "shared/components/button";
import Variant from "shared/enums/Variant";
import classNames from "classnames";
import { ActivitySelectionStatus } from "shared/enums/ActivitySelectionStatus";
import TopNoteWithApi from "shared/components/topNote/topNoteWithApi";
import ContextEntityType from "shared/enums/ContextEntityType";
import UtilityDataModule from "shared/enums/UtilityDataModule";
import { useRegDetail } from "../../../../shared/context/regDetail";
import SelectableActivityDropdown from "../../../../shared/components/activity/list/components/selectableActivityDropdown";
import { useMyExpAnalytics } from "apps/myExperience/context/analyticsWrapper";
import useLogAnalyticsScreenHook from "apps/myExperience/context/analyticsWrapper/hooks/useLogAnalyticsScreenHook";
import { AnalyticsContextEntityTypeEnum, AnalyticsScreenNameEnum } from "shared/enums/AnalyticsEnums";

export default function ShortlistParticipantsForActivityMyExperience() {
  const { programParticipantId = "" } = useParams();
  const { currencyCode, localeId } = useRegDetail();
  const behavior = useAssociatedProgramBehaviourFactory();
  return (
    <ShortlistParticipantServiceProvider
      behavior={behavior}
      id={programParticipantId}
      currencyCode={currencyCode}
      localeId={localeId}>
      <ShortlistParticipant />
    </ShortlistParticipantServiceProvider>
  );
}
export function ActivityDropdown() {
  const service = useMyExperienceshortlistService();
  return (
    <React.Fragment>
      <SelectableActivityDropdown
        selectHandler={service.handleSetSelectedActivity}
        activityList={service.activityList}
        selectedActivityId={service.selectedActivity}
      />
    </React.Fragment>
  );
}
export function ShortlistFilteringAndListing() {
  const { logEvent } = useMyExpAnalytics();
  const service = useMyExperienceshortlistService();
  const copies = useCopies();

  return (
    <React.Fragment>
      <div className="shortlistParticipant filtersAndListing">
        <TopNoteWithApi
          registrationId={service.registrationId ?? ""}
          contextEntityType={ContextEntityType.PROGRAM}
          contextEntityId={service.programId ?? ""}
          module={UtilityDataModule.ACTIVITY_ADMIN_SHORTLIST}
          logEvent={logEvent}
        />
        <div className="filtersAndListing-body">
          <div className="filtersAndListing-filters">
            <div className="filtersAndListing-filters_title">
              <div className="block"></div>
            </div>
            <div className="filtersAndListing-filters_wrapper">
              <span className="filtersAndListing-filters_inner_title">
                <span className="label">{copies.get("status")}</span>
                <Button
                  variant={Variant.LINK}
                  label={copies.get("clear.all")}
                  onClick={() => service.setFilters([])}
                  disabled={service.filters.length === 0}
                />
              </span>
              <div className="filtersAndListing-filters_inner_body">
                <div className="filtersAndListing-filters_inner_body_item">
                  <CheckBox
                    checked={service.filters.includes(ActivitySelectionStatus.PENDING)}
                    name=""
                    label={`${copies.get("associated.program.pending.shortlist.action")} (${
                      service.counts[ActivitySelectionStatus.PENDING]
                    })`}
                    onChange={() => {
                      service.setFilters(xor(service.filters, [ActivitySelectionStatus.PENDING]));
                    }}
                  />
                </div>
                {service.shortlistOptions.map(item => (
                  <div className="filtersAndListing-filters_inner_body_item" key={item.value}>
                    <CheckBox
                      checked={service.filters.includes(item.value)}
                      name=""
                      label={item.customData?.navLabel}
                      onChange={() => {
                        service.setFilters(xor(service.filters, [item.value]));
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="filtersAndListing-listing">
            <div className="filtersAndListing-listing_inner_topAction">
              <div className="selectActivityHeader">
                <ActivityDropdown />
              </div>
            </div>
            <div className="filtersAndListing-listing_inner">
              <Outlet context={{ filters: service.filters }} />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
export function ShortlistParticipant() {
  const service = useMyExperienceshortlistService();

  useLogAnalyticsScreenHook({
    properties: {
      screenType: AnalyticsScreenNameEnum.ACTIVITY_SHORTLIST_PARTICIPANTS,
      programParticipantId: service.programParticipantId,
      contextEntityType: service.selectedActivity ? AnalyticsContextEntityTypeEnum.ACTIVITY : undefined,
      contextEntityId: service.selectedActivity
    },
    refreshKey: service.selectedActivity
  });

  const copies = useCopies();
  return (
    <React.Fragment>
      {service.selectedActivity ? (
        <ShortlistFilteringAndListing />
      ) : (
        <div className={classNames("apShortlist--myExp", "profile_wrapper")}>
          <div className={classNames("apShortlist--myExp_filter", "noFilterSelected")}>
            <span className="noFilterSelected_message">{copies.get("associate.program.select.activity.message")}</span>
            <ActivityDropdown />
          </div>
        </div>
      )}
    </React.Fragment>
  );
}
